<template>
  <v-dialog
    v-model="dialog"
    width="auto"
  >
    <v-card @click="dialog = false">
      <v-card-text class="pt-6 pb-2">
        <h1>Sommarbuffe</h1><br>
        <h2>Ingredienser:</h2><br>
        Tomat/mozzarellasallad (cocktailtomat, mozzarellaost (KOMJÖLK, löpe, syra E330, mjölksyrakultur)), pesto 9% (basilika, solrosolja, OST (PARMIGIANO REGGIANO, pecorino (MJÖLK, salt, löpe)), CASHEWNÖTTER, potatisflingor, olivolja, salt, socker, pinjenötter, aromer, vitlök, surhetsreglerande medel E270), pinjenötter 4%, ruccolasallad, olivolja), cantaloupe- melon, jordgubbar, surdegsbröd (bakmix (VETEMJÖL, VETEGLUTEN, mjölbehandlingsmedel (amylas E300)), levainsurdeg (av VETE), vatten, RÅGSURDEG, DURUMVETEMJÖL, salt, jäst), Appenzellerost 4% (opastöriserad MJÖLK, salt, löpe, mjölksyrakultur), Brieost 7% (MJÖLK, salt (kraftigt saltad), mjölksyra- kultur, mögelkultur, mikrobiellt ystenzym), Affinéost 4% (MJÖLK, GRÄDDE, salt, mikrobiella koagulanter, mjölksyrakultur, mögelkultur)), Serranoskinka (skinka av gris, salt, dextros, konserveringsmedel (E252 E250), antioxidationsmedel E300), kex mini twist (VETEMJÖL, SMÖR 28%, OST 10%, SKUMMJÖLKSPULVER, salt, jäst, KORNMALTMJÖL, socker), tapaskorv 3% (fläskkött, fett fläsk, vatten, koksalt, socker, druvsocker, kryddor, vitlökspulver, cayennepeppar, konserverings- medel E250, antioxidationsmedel E301), Saltufo salami (griskött, grisfett, PARMIGIANO REGGIANO OST 11%, salt, sommartryffel (Tuber aestivum) 3%, kryddor (innehåller SENAP), MJÖLKPROTEIN, grisgelatin, druvsocker, arom, maltodextrin, hydrolyserat veg.protein, konserverings- medel (E252 E202), antioxidationsmedel E301), Salami Milano (fläskkött, salt, dextros, kryddor, aromer, antioxidationsmedel E301, konserveringsmedel (E250, E252)), Chorizo stickor (fläskkött, fett från gris, salt, paprika, LAKTOS, SKUMMJÖLKSPULVER, druvsocker, dextrin, MJÖLKPROTEIN, kryddor, stabiliseringsmedel (E450, E451), rökarom, antioxidationsmedel E301, konserveringsmedel (E252, E250), färgämne E120), blåbär, hallon, Salami Ventrecina (fläskkött, chilipeppar, salt, druvsocker, kryddor, aromer, antioxidationsmedel E301, konserveringsmedel (E250 E252)), Körsbärssalsa (kanderade körsbär (körsbär, glukos- fruktossirap, socker, koncentrerad körsbärsjuice, syra E330, färgämne E163, aromämnen, antioxidationsmedel E220 (SULFIT), socker, vatten, glukossirap, SENAPSAROM, aromämnen, syra E330)). Kan innehålla spår av VALNÖT, MAKADAMIANÖT, PEKANNÖT, PARANÖT, PISTAGENÖT, MANDEL, HASSELNÖT, JORDNÖT, SOJA och SESAM.
        <br><br><hr><br>
        <h1>Kalkon och Rostbiffsbuffé</h1><br>
        <h2>Ingredienser:</h2><br>
        Marinerade grönsaker (grönsaker (broccoli, blomkål, morot, paprika, inlagd syltlök (innehåller SENAP, SULFIT),rödlök), dressing (rapsolja, vitvinsvinäger (innehåller SULFIT), sweet chilissås (vatten,socker, chilipeppar, paprika, salt, modifierad stärkelse, surhetsreglerande medel E260, vitlök, lök, förtjockningsmedel E415, konserveringsmedel E202), socker, kryddor (rosmarin, persilja, mejram, oregano, timjan, basilika, kyndel, dragon), svartpeppar, salt), grillad rostbiff 11% (nötinnanlår 92%, salt, kryddor, druvsocker, kryddextrakt (svartpeppar), potatisfiber, antioxidations- medel E301, stabiliseringsmedel E451), kalkonbröst 11% (kalkon 88%, vatten, salt, stabiliseringsmedel (E450, E451),druvsocker, antioxidationsmedel (E301, E325),kons medel E250), bröd (brödmix (VETEMJÖL, VETEGLUTEN, mjölbehandlingsmedel (amylas, E300), surdeg av VETE och RÅG, vatten, DURUMVETEMJÖL, salt, jäst), vindruvor, cantaloupemelon, passionsfrukt, kiwi, sallad, physalis, bladpersilja.
        <br><br><hr><br>
        <h2>Allergiinformation</h2><br>
        Kan innehålla spår av VALNÖT, MAKADAMIANÖT, PEKANNÖT, PARANÖT, PISTAGENÖT, MANDEL, HASSELNÖT, JORDNÖT, SOJA och SESAM.
        <br><br><hr>
        <div align="center"><i>{{ getUserId() }}</i></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getUserId } from "@/base/user.js"
export default {
  name: "Info",
  props: ['show'],
  data: function () {
    return {
      getUserId
    };
  },
  watch: {
  },
  methods: {

  },
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("close");
      }
    }
  },
  destroyed() {

  },
  mounted() {

  }
};
</script>
